import { IInventoryItemsQueryParams, InventoryType } from "gen/ApiClient";
import { isOfType } from "./isOfType";

export const isSingleOfType = (params: IInventoryItemsQueryParams, type: InventoryType) =>  
    params.types.length === 1 && isOfType(params.types[0], type);

